import React from 'react';
import { Result } from 'antd';

import { useVismaConfiguration } from '@services/visitor-management';
import { useConfigurationStore } from '@store/use-configuration-store';

import type { ApiError } from '../../types';
import Layout from './index';
import LayoutPlaceholder from './layout-placeholder';

interface WithConfigurationLoaderProps {
  children: React.ReactNode;
}

export function WithConfiguration({ children }: WithConfigurationLoaderProps) {
  const { friendly_url, module } = useConfigurationStore();
  const { isLoading, isError, error } = useVismaConfiguration();

  if (!friendly_url || !module) {
    return (
      <Layout>
        <Result
          status="error"
          title="Configuration not loaded"
          subTitle="No configuration found. Please access the app through a valid URL."
        />
      </Layout>
    );
  }

  if (isLoading) {
    return <LayoutPlaceholder />;
  }

  if (isError) {
    return (
      <Layout>
        <Result
          status="error"
          title="Failed to load configuration"
          subTitle={(error as ApiError)?.response?.data?.errorMessage}
        />
      </Layout>
    );
  }

  return <>{children}</>;
}

export default WithConfiguration;
